import React from "react";
// Import your image
import aboutImg from "../../assets/img/about/Cab1.png";
// Import Material-UI icons
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import DriveEtaIcon from "@mui/icons-material/DriveEta";

const AboutArea = () => {
  return (
    <div>
      <style jsx>{`
        .site-title {
          color: #000000 !important;
        }
        .site-title span {
          color: #000000 !important;
        }
      `}</style>

      <div className="about-area py-120">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="about-left wow fadeInLeft" data-wow-delay=".25s">
                <div className="about-img">
                  <img src={aboutImg} alt="About us" />
                </div>
                <div className="about-experience">
                  <div className="about-experience-icon">
                    <DirectionsCarIcon
                      sx={{
                        fontSize: 60,
                        color: "#ff4800",
                        backgroundColor: "white",
                        borderRadius: "50%",
                        padding: "10px",
                        boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                      }}
                    />
                  </div>
                  <b>
                    Pioneering <br /> Urban Mobility
                  </b>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="about-right wow fadeInRight"
                data-wow-delay=".25s"
                style={{ textAlign: "left" }}
              >
                <div
                  className="site-heading mb-3"
                  style={{ textAlign: "left" }}
                >
                  <span
                    className="site-title-tagline"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                    }}
                  >
                    <DriveEtaIcon
                      sx={{
                        fontSize: 20,
                        marginRight: "8px",
                        color: "#ff4800",
                      }}
                    />
                    About Us
                  </span>
                  <h2
                    className="site-title"
                    style={{
                      color: "#000000 !important",
                      textAlign: "left",
                      WebkitTextFillColor: "#000000",
                      MozTextFillColor: "#000000",
                    }}
                  >
                    Revolutionizing{" "}
                    <span
                      style={{
                        color: "#098535 !important",
                        WebkitTextFillColor: "#098535",
                        MozTextFillColor: "#098535",
                      }}
                    >
                      City Travel
                    </span>{" "}
                    Together
                  </h2>
                </div>
                <p
                  className="about-text"
                  style={{ textAlign: "left", color: "#000000" }}
                >
                  CabandGo is your next-generation mobility platform that's
                  transforming how people move around the city. We bring
                  together the best of Cab, Keke, Okada, and Logistics services
                  into one seamless experience, ensuring you get where you need
                  to be - faster, safer, and smarter.
                </p>
                <div
                  className="about-list-wrapper"
                  style={{ textAlign: "left" }}
                >
                  <ul
                    className="about-list list-unstyled"
                    style={{ color: "#000000" }}
                  >
                    <li>Instant booking with live driver tracking</li>
                    <li>Transparent pricing with no hidden charges</li>
                    <li>Safety-first approach with verified partners</li>
                    <li>Rated and reviewed service providers</li>
                    <li>User-friendly app for effortless booking</li>
                    <li>Multiple transport options at your fingertips</li>
                  </ul>
                </div>
                <div style={{ textAlign: "left" }}>
                  <a href="about.html" className="theme-btn mt-4">
                    Join The Movement
                    <i
                      className="fas fa-arrow-right"
                      style={{ marginLeft: "8px" }}
                    ></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutArea;
